module.exports = __webpack_public_path__ + "img/男-慢性肾病h.f7bba639.png";